import { Stores, PushNotification } from "../types";
import { makeAutoObservable } from "mobx";
import api from "../services/api";

export class PushNotificationsStore {
  stores: Stores;

  pushNotifications: PushNotification[] = [];

  isLoading = false;

  constructor(stores: Stores) {
    this.stores = stores;

    makeAutoObservable(this);
  }

  getPushNotifications = async () => {
    this.isLoading = true;
    try {
      const pushNotifications = await api.getPushNotifications();
      this.setPushNotifications(pushNotifications);
    } catch (err) {
      throw err;
    } finally {
      this.isLoading = false;
    }
  };

  addPushNotification = async (data: PushNotification) => {
    this.isLoading = true;
    try {
      const pushNotification = await api.addPushNotification(data);

      this.setPushNotifications(
        [pushNotification, ...this.pushNotifications].sort(
          (a, b) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        )
      );
    } catch (err) {
      throw err;
    } finally {
      this.isLoading = false;
    }
  };

  // Setters

  setPushNotifications = (pushNotifications: PushNotification[]) => {
    this.pushNotifications = pushNotifications;
  };
}
